
















































import NumeralInput from "../../core/Forms/NumeraInput.vue";
import { Employe } from "../../models/Employe";
import { DateUtils } from "../../utils/DateUtils";

export default {
    name: "NoteDeFraisEdit",
    components: { NumeralInput },
    props: {
        noteDeFrais: Employe.NoteDeFrais,
        distances: Array,
    },
    computed: {
        totalKm() {
            return _.round(
                _.reduce(
                    this.distances,
                    function (sum, trajet) {
                        return sum + trajet.distance.distance / 1000;
                    },
                    0
                ),
                2
            );
        },
        totalFraisKm() {
            return _.round(this.totalKm * this.noteDeFrais.taux_km, 2);
        },
    },
    methods: {
        updateMontantKm() {
            this.noteDeFrais.total_km = this.totalKm;
            this.noteDeFrais.montant_km = this.totalFraisKm;
        },
        humanReadableDate(str: string) {
            return DateUtils.sqlToDateStr(str);
        },
    },
    watch: {
        totalKm: {
            immediate: true,
            handler: "updateMontantKm",
        },
        "noteDeFrais.taux_km": {
            immediate: true,
            handler: "updateMontantKm",
        },
    },
};
